module.exports = __webpack_public_path__ + "assets/img/ds1.f2eca600.jpg";